import { mdiCreditCardOutline, mdiCreditCardWirelessOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Grid, Typography } from '@mui/material';

import { Colors } from '../../../shared/colors';
interface PropsCartao {
  numero: string;
  tipo: 'Cartão Físico' | 'Cartão Digital';
}
export default function NumeroCartao({ numero, tipo }: PropsCartao) {
  const icone = tipo === 'Cartão Físico' ? mdiCreditCardOutline : mdiCreditCardWirelessOutline;

  return (
    <Grid container>
      <Grid item>
        <Typography color={Colors.white} variant="body2" align="left">
          {tipo}
        </Typography>
      </Grid>
      <Grid gap={0.5} item container display="flex" alignItems="center">
        <Box>
          <Icon color={Colors.primary.main} path={icone} size={0.8} />
        </Box>

        <Typography
          color={Colors.white}
          variant="body2"
          fontSize={{ xs: '0.7rem', sm: '0.7rem', lg: '0.9rem' }}
        >
          {numero}
        </Typography>
      </Grid>
    </Grid>
  );
}
